






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { ModalOptions } from '../../models/modal.interface';

@Component
export default class Modal extends Vue {
  @Action('hideModalAction') public hideModalAction!: () => void;
  @Action('validateModalAction') public validateModalAction!: () => void;
  @Getter public isModalOpened!: boolean;
  @Getter private modalOptions!: ModalOptions;

  public validate() {
    return this.validateModalAction();
  }

  public hide() {
    this.hideModalAction();
  }
}
